import { render, staticRenderFns } from "./BtDashboardSettings.vue?vue&type=template&id=d168485e&"
import script from "./BtDashboardSettings.vue?vue&type=script&lang=js&"
export * from "./BtDashboardSettings.vue?vue&type=script&lang=js&"
import style0 from "./BtDashboardSettings.vue?vue&type=style&index=0&id=d168485e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports